import { call, put, takeLatest } from "redux-saga/effects";
import { homeAPI } from "../api/api";
import { HomeActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";
import { authStore } from "../../auth/store/store";

function* getUserInfo(action) {
    try {
        const response = yield call(homeAPI.getUserInfo);
        yield put({
            type: HomeActionTypes.GET_USER_INFO_SUCCESS,
            payload: response.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting user info.");

        yield put({
            type: HomeActionTypes.LOGOUT,
            message: e.message
        });
    }
}

export function* getUserInfoWatcher() {
    yield takeLatest(HomeActionTypes.GET_USER_INFO, getUserInfo);
}

function* editUserPassword(action) {
    authStore.dispatch({
        type: HomeActionTypes.EDIT_USER_PASSWORD,
        payload: action.payload
    });
}

export function* editUserPasswordWatcher() {
    yield takeLatest(HomeActionTypes.EDIT_USER_PASSWORD, editUserPassword);
}
